import { ChangeEvent, useMemo, useState } from 'react';
import { RemoveErrorType, SetErrorType } from '../../../../../hooks/useErrors';
import onlyNumbers from '../../../../../utils/onlyNumbers';

interface UseAffreightmentsTabI {
  setError: SetErrorType;
  removeError: RemoveErrorType;
}

export default function useAffreightmentsTab({ setError, removeError }: UseAffreightmentsTabI) {
  const [losesOwnershipWithoutBoarding, setLosesOwnershipWithoutBoarding] = useState(false);
  const [daysAllowedWithoutBoarding, setDaysAllowedWithoutBoarding] = useState<number | string>('');
  const [usaHorarioFretado, setUsaHorarioFretado] = useState(true);

  const isAffreightmentsTabValid = useMemo(() => ((!!losesOwnershipWithoutBoarding && !!daysAllowedWithoutBoarding) || (!losesOwnershipWithoutBoarding)), [daysAllowedWithoutBoarding, losesOwnershipWithoutBoarding]);

  function handleDaysAllowedWithoutBoardingChange(event: ChangeEvent<HTMLInputElement>) {
    setDaysAllowedWithoutBoarding(onlyNumbers(event.target.value));

    if (!event.target.value && losesOwnershipWithoutBoarding) {
      setError({ field: 'daysAllowedWithoutBoarding', message: 'Este campo é obrigatório no caso do colaborador perder a titularidade'});
    } else {
      removeError('daysAllowedWithoutBoarding');
    }
  }

  function handleLosesOwnershipWithoutBoardingChange(losesOwnership: boolean) {
    if (losesOwnership) {
      setLosesOwnershipWithoutBoarding(true);
    } else {
      setLosesOwnershipWithoutBoarding(false);
      removeError('daysAllowedWithoutBoarding');
    }
  }

  return {
    losesOwnershipWithoutBoarding,
    setLosesOwnershipWithoutBoarding,
    daysAllowedWithoutBoarding,
    setDaysAllowedWithoutBoarding,
    usaHorarioFretado,
    setUsaHorarioFretado,
    isAffreightmentsTabValid,
    handleDaysAllowedWithoutBoardingChange,
    handleLosesOwnershipWithoutBoardingChange,
  };
}
